import { useEffect, useState } from "react";
import { ProvinceClient, ProvinceDTO } from "../services/apiClient";
import axiosInstance from "../services/axiosInstance";
import { API_BASE_URL } from "../config/config";

export const getProvinces = () => {
  const [provinces, setProvinces] = useState<ProvinceDTO[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const provinceClient = new ProvinceClient(API_BASE_URL, axiosInstance);

  useEffect(() => {
          const fetchProvinceNames = async () => {
              setIsLoading(true);
              try {
                  const result = await provinceClient.getProvinces(); // Call the distinct table names endpoint
                  if (result && result.success && result.data) {
                    setProvinces(result.data);
                  } else {
                      setError('Failed to fetch province names');
                  }
              } catch (err) {
                  setError('Error fetching province status names');
                  console.error('Error fetching province status names:', err);
              } finally {
                  setIsLoading(false);
              }
          };
  
          fetchProvinceNames();
      }, []);
  
      return { provinces, isLoading, error };
};
